import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import Text from 'components/Text';
import StyledRichText from 'components/RichText/StyledRichText';
import CallToAction from 'components/CallToAction';
import getBreakpointView from 'utils/getBreakpointView';

import { Container } from './styles';

const WistiaCta = ({ callToAction, ctaBody, ctaTitle, isPlaying, ratio, videoRef, videoId }) => {
  const [ctaHeight, setCtaHeight] = useState(null);
  const isMobile = getBreakpointView(['xs', 'sm']);

  useEffect(() => {
    const cta = document.querySelector(`#wistia-popover-cta-${videoId}`);

    if (cta) {
      setCtaHeight(cta.clientHeight);
    }
  }, [ratio]);

  useEffect(() => {
    if (isPlaying) {
      const video = videoRef?.current?.getInternalPlayer();

      if (video) {
        const videoContainer = video.options.container;
        const videoHeight = video.videoHeight();
        const cta = document.querySelector(`#wistia-popover-cta-${videoId}`);
        const closeButton = document.querySelector('.wistia_placebo_close_button');
        const popoverWrapper = document.querySelector(`#${videoContainer}_popover`);
        video.videoHeight(videoHeight - 40 - ctaHeight, { constrain: true });
        popoverWrapper.style.marginTop = `-${ctaHeight / 2 + 40}px`;
        closeButton.style.marginTop = isMobile ? '-160px' : '-110px';

        setTimeout(() => {
          cta.style.visibility = 'visible';
          cta.style.marginTop = `-${ctaHeight / 2 + 40}px`;
          cta.style.position = 'relative';
          cta.style.top = '20px';
          cta.style.opacity = 1;
        }, 2500);
      }
    }
  }, [isPlaying]);

  return (
    <Container
      id={`wistia-popover-cta-${videoId}`}
      className="wistia-popover-cta"
      style={{
        display: 'block !important',
        width: '100%',

        background: 'var(--blue-5)',
        padding: '25px',
        visibility: 'hidden',
        position: 'fixed',
        top: '-999px',
        opacity: 0,
        color: 'white',
        transition: 'top opacity 1s ease-in-out',
      }}
    >
      <Row gutter={30}>
        <Col xs={24} sm={18}>
          <h4>{ctaTitle}</h4>
          {ctaBody.json ? (
            <StyledRichText content={ctaBody.json} />
          ) : (
            <Text type="p">{ctaBody}</Text>
          )}
        </Col>
        <Col xs={24} sm={6} className="wistia-popover-cta--button">
          <CallToAction {...callToAction} textLabel={null} />
        </Col>
      </Row>
    </Container>
  );
};

export default WistiaCta;
